import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.scss';

// Configuração simples de usuários para o login por imagem
const IMAGE_USERS = [
  { id: 'miguel', name: 'Miguel', img: '/assets/img/service/routes-admin.jpg', password: '123' },
  { id: 'felipe', name: 'Felipe', img: '/assets/img/service/routes-admin.jpg', password: '456' },
  { id: 'willians', name: 'Willians', img: '/assets/img/service/routes-admin.jpg', password: '123456' }
];

function ImageLogin() {
  const [selected, setSelected] = useState(null);
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSelect = (userId) => {
    setSelected(userId === selected ? null : userId);
  }

  const handleSubmit = () => {
    const user = IMAGE_USERS.find(u => u.id === selected);
    if (!user) {
      alert('Selecione um usuário.');
      return;
    }
    if (password === user.password) {
      // login local simples
      sessionStorage.setItem('responsavel', user.name);
      sessionStorage.setItem('user', JSON.stringify({ id: user.id, name: user.name }));
      sessionStorage.setItem('isAuthenticated', 'true');
      navigate('/agenda');
    } else {
      alert('Senha incorreta.');
    }
  }

  return (
    <div className="login-area space__bottom--r120">
      <div className="container">
        <div className="row">
          <div id="login-form" className="col-sm-12 col-md-12 col-xs-12 col-lg-8 mx-auto">
            <form name="imageLogin" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
              <div className="login-form">
                <div className="row">
                  <div className="col-12 mb-4">
                    <div className="grid-users" style={{display: 'flex', gap: '16px', justifyContent: 'center'}}>
                      {IMAGE_USERS.map(u => (
                        <div key={u.id} onClick={() => handleSelect(u.id)} className={`user-card ${selected === u.id ? 'selected' : ''}`} style={{cursor: 'pointer', textAlign: 'center'}}>
                          <img src={u.img} alt={u.name} style={{width: 140, height: 100, objectFit: 'cover', borderRadius: 8, border: selected === u.id ? '3px solid #4f46e5' : '2px solid #ddd'}} />
                          <div style={{marginTop: 8, fontWeight: 600}}>{u.name}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="col-md-12 col-12 space__bottom--20">

                    {/* Display mascarado */}
                    <div style={{textAlign:'center', marginTop:8, marginBottom:12}}>
                      <div style={{display:'inline-flex', gap:8, padding:8, borderRadius:8, background:'#fff', border:'1px solid #e5e7eb'}}>
                        {Array.from({length: password.length}).map((_,i) => (
                          <div key={i} style={{width:14, height:14, borderRadius:7, background:'#111'}}></div>
                        ))}
                        {password.length === 0 && <div style={{color:'#9ca3af'}}>nenhum</div>}
                      </div>
                    </div>

                    {/* Teclado numérico */}
                    <div className="pin-pad" style={{display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:12, maxWidth:360, margin:'0 auto'}}>
                      {[1,2,3,4,5,6,7,8,9].map(n => (
                        <button key={n} type="button" onClick={() => setPassword(p => p + String(n))} className="default-btn" style={{padding:'18px 0', fontSize:20, borderRadius:8}}>{n}</button>
                      ))}

                      <button type="button" onClick={() => setPassword('')} className="default-btn" style={{padding:'18px 0', fontSize:16, borderRadius:8}}>CLR</button>
                      <button type="button" onClick={() => setPassword(p => p + '0')} className="default-btn" style={{padding:'18px 0', fontSize:20, borderRadius:8}}>0</button>
                      <button type="button" onClick={() => setPassword(p => p.slice(0, -1))} className="default-btn" style={{padding:'18px 0', fontSize:18, borderRadius:8}}>⌫</button>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <button type="submit" className="default-btn mt-0">Entrar</button>
                  </div>

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImageLogin;
